import api from '../services/config/api';
import { IComment, IIndexComment } from 'types/demands';
import { ReactText } from 'react';

/**
 *
 * @example
 * ```tsx
 *  const formData = new FormData();
 *  formData.append('solicitacaoComentarioDto', new Blob([JSON.stringify({ description: 'text' })], { type: 'application/json' }))
 *  files.forEach(file => formData.append('files', file));
 *  await createComment(5, formData)
 * ```
 */
export const createComment = (id: ReactText, data: FormData) =>
  api.post(`/solicitacao/${id}/solicitacao-comentario`, data);

export const listComments = (id: ReactText) =>
  api.get<IComment[]>(`/solicitacao/${id}/solicitacao-comentario`);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getAnexoComment = (id: ReactText, page?: number, size?: number, sort?: string) =>
  api.get<IIndexComment>(
    `/solicitacao/${id}/anexo-comentario?`,
    // `/solicitacao/${id}/anexo-comentario?page=${page}&size=${size}&sort=${sort}`,
  );

export const downloadFile = (id: ReactText) =>
  api.get<Blob>(`/solicitacao/download/${id}/solicitacao-comentario`, { responseType: 'blob' });
